export default __webpack_public_path__ + "static/media/New-Battery-01.eba07a3a.jpg";